export default __webpack_public_path__ + "static/media/Ooty1.4d08da0e.jpg";